import {Paper, styled} from '@mui/material';

export const AsideContainer = styled('aside')`
	justify-content: space-between;
	align-items: flex-end;
	flex-direction: row;
	position: sticky;
	display: flex;
	padding: 24px;
	height: 100vh;
	gap: 16px;
	flex: 1;
	top: 0;
`;

export const SectionContainer = styled(Paper)`
	flex-direction: column;
	display: flex;
	z-index: 1;
	gap: 16px;
	flex: 1;
	border-bottom-left-radius: 0px;

	${({theme}) => theme.breakpoints.up('md')} {
		max-width: 437px;
	}
`;
